import React from 'react';
import {ButtonBase} from '../../../elements';
import {ReactComponent as ArrowDownIcon} from '../../icons/round-arrow_drop_down.svg';
import styled from 'styled-components';
import {MarketGroupItem} from "./MarketSelectionMenu";
import {MarketGroup} from "../../../../markets/marketMapping";
import {useTranslation} from "react-i18next";

const MarketItemStyled = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;
MarketItemStyled.displayName = 'MarketItemStyled';

const MarketChoiceButton = styled(ButtonBase)<{bgColor?: string}>`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 11px;
    background-color: ${props => props.bgColor};
`;


const SelectionShortTitlesContainer = styled.div<{ length: number }>`
    display: grid;
    grid-template-columns: repeat(${props => props.length}, 1fr);
    color: #ABABAB;
`;
SelectionShortTitlesContainer.displayName = 'SelectionShortTitlesContainer';

const SelectionShortTitle = styled.div`
    text-align: center;
`;
SelectionShortTitle.displayName = 'SelectionShortTitle';

function getShortSelectioname(selectionName: string) {
    return selectionName.length <= 3
        ? selectionName
        : selectionName.slice(0, 3) + '...' + selectionName.slice(-1);
}

type MarketItemProps = {
    currentMarketGroupItem: MarketGroupItem;
    columnTitles: string[];
    color?: string;
    updatePopupList: (currentMarketGroupItem: MarketGroup, event: React.MouseEvent) => void;
};

export function MarketItem(props: MarketItemProps) {
    const {color, columnTitles, currentMarketGroupItem, updatePopupList} = props;
    const {t} = useTranslation();


    function onClickMarketButton2(event: React.MouseEvent) {
        updatePopupList(currentMarketGroupItem.marketGroup, event);
    }

    return (
        <div className="w-[130px] desktop:w-[250px] flex flex-col">
            <MarketChoiceButton onClick={onClickMarketButton2} bgColor={color} className={`text-[10px] desktop:text-[16px]`}>
                {t(currentMarketGroupItem.marketGroup)} <ArrowDownIcon/>
            </MarketChoiceButton>

            <SelectionShortTitlesContainer length={columnTitles.length}>
                {columnTitles.map((title, index) => (
                    <SelectionShortTitle key={index}>
                        {t(getShortSelectioname(title))}
                    </SelectionShortTitle>
                ))}
            </SelectionShortTitlesContainer>
        </div>
    );
}
